import {
  Avatar,
  Box,
  Stack,
  Typography,
  IconButton,
  Grid,
  Button,
  useMediaQuery,
} from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import User from 'assets/icons/UserProfile.svg';
import Monetize from 'assets/icons/dollar.svg';
import Detoast from 'assets/icons/detoast.svg';
import BlueTick from 'assets/icons/blueTick.svg';
import FHB from 'assets/icons/fhb.svg';
import Phone from 'assets/icons/callPhone.svg';
import Location from 'assets/icons/locationMap.svg';
import Mail from 'assets/icons/mail.svg';
import { ReactComponent as CircularChart } from 'assets/icons/CircularBar.svg';
import BuyerReadiness from 'assets/images/buyerReadiness.jpg';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useTheme } from '@emotion/react';
import Loading from 'assets/images/loading.png';
import {
  fontsize14,
  poppins300,
  poppins400,
  poppins500,
  poppins600,
} from 'theme/common.style';
import {
  Arrow2,
  ExpandIcon,
  IOSSwitch,
  RightArrow,
} from 'component/OwnerCard/OwnerCard';
import { LoaderContext } from 'component/Loader/LoaderContextProvider';
import { getApiCall } from 'api/apiService';
import { GET_BuyersCard } from 'constant/app.config';
import { toast } from 'react-toastify';
import NameTooltip from 'component/Common/NameTooltip';

const ToggleOff = () => {
  return (
    <svg
      width="42"
      height="25"
      viewBox="0 0 42 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="gradient" gradientTransform="rotate(90)">
          <stop offset="0%" stop-color="rgba(108, 42, 210, 1)" />
          <stop offset="100%" stop-color="rgba(119, 207, 254, 1)" />
        </linearGradient>
      </defs>
      <rect
        width="41.54"
        x="0.460938"
        y="0.370605"
        height="24.3705"
        rx="12.1852"
        fill="url(#gradient)"
      />
      <ellipse
        cx="12.982"
        cy="12.5558"
        rx="8.52103"
        ry="8.86199"
        fill="white"
      />
    </svg>
  );
};

export const BuyerCardProfile = (props) => {
  const {
    loading,
    count,
    showBackdrop,
    selectedBuyers,
    setSelectedBuyers,
    selectedBuyerId,
    setSelectedBuyerId,
    marketShow,
    setMarketShow,
    buyerId,
    openOwner,
    setOpenOwner,
    open,
    setOpen,
    userType,
    onClick,
    expand,
    setExpand,
    show,
    setShow,
    isHiddenRightArrow,
    setIsHiddenRightArrow,
    tableData,
    buyercard,
    buyerName,
    setBuyerName,
    setLoading,
    fromSearch,
    buyerpropertylist,
    proid,
  } = props;
  const { setLoaderConfig } = useContext(LoaderContext);
  const [profileDetails, setProfileDetails] = useState({});
  const [isHidden, setIsHidden] = useState(false);

  const [hideExpand, setHideExpand] = useState(false);

  const getListInfo = async (buyerId, proid) => {
    setLoaderConfig({ isVisible: false });
    setLoading(true);
    try {
      const res = await getApiCall(
        `${GET_BuyersCard}/Buyer/${buyerId}/${proid}`
      );
      if (res?.data?.status == '-1') {
        toast.error(res?.data?.message, {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          progress: 0,
          theme: 'light',
          style: {
            fontFamily: 'Poppins', // 👈 Inline Poppins font
          },
        });
      } else {
        setProfileDetails(res?.data);
        setBuyerName(res?.data?.BuyerDetails?.user?.userName);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!buyerId || !proid) {
      return;
    }
    setLoaderConfig({ isVisible: false });
    getListInfo(buyerId, proid);
  }, [buyerId, proid]);
  const data = profileDetails?.BuyerDetails;

  const currentPage = window.location.pathname;

  useEffect(() => {
    if (fromSearch && buyerpropertylist != {}) {
      setExpand(!expand);
      setIsHidden(true);
    }
  }, [buyerpropertylist]);
  function toggleShow() {
    setShow(!show);
  }
  var buttonText = show ? (
    <Typography
      sx={{
        fontFamily: 'Poppins !important',
        fontStyle: 'normal !important',
        fontWeight: '600 !important',
        fontSize: '12px',
      }}
    >
      <Grid
        item
        sx={{
          display: 'flex',
          direction: 'row',
          spacing: '2',
          textTransform: 'capitalize',
        }}
      >
        <Grid item sx={{ pr: 1 }}>{`collapse  `}</Grid>
        <Grid item>
          <Arrow2 />
        </Grid>
      </Grid>
    </Typography>
  ) : (
    <Typography
      sx={{
        fontFamily: 'Poppins !important',
        fontStyle: 'normal !important',
        fontWeight: '600 !important',
        fontSize: '12px',
      }}
    >
      <Grid
        item
        sx={{
          display: 'flex',
          direction: 'row',
          spacing: '2',
          textTransform: 'capitalize',
        }}
      >
        {' '}
        <Grid item sx={{ pr: 1 }}>
          expand
        </Grid>{' '}
        <Grid item>
          <Arrow2 />
        </Grid>
      </Grid>
    </Typography>
  );

  const theme = useTheme();
  const matches870 = useMediaQuery(theme.breakpoints.down(870));
  const matches1000 = useMediaQuery(theme.breakpoints.down(1000));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const matches370 = useMediaQuery(theme.breakpoints.down(370));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '15px',
        width: buyercard && matchessm ? '100%' : '365px',
        height: matchessm ? 'fit-content' : '540px',
        background: '#FFFFFF',
        borderRadius: '10px, 0px, 0px, 10px',
      }}
    >
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={
          expand && !matches870
            ? 'right'
            : expand && matches870
            ? 'space-between'
            : 'space-between'
        }
        sx={{
          margin: '0',
          width: '90%',
          height: matchessm ? '0px' : '30px',
          marginTop: matchessm ? '0px' : '10px',
        }}
      >
        {data?.user == null ? (
          <Box sx={{ width: '10px', height: '10px' }}></Box>
        ) : (
          <>
            {(isHidden && expand) || matchessm ? null : (
              <IconButton
                sx={{ zIndex: 1 }}
                onClick={() => {
                  setExpand(!expand);
                  setIsHidden(true);
                }}
              >
                <ExpandIcon />
              </IconButton>
            )}
          </>
        )}

        {userType === 'Both' && !matchessm && (
          <Stack
            justifyContent={'space-around'}
            direction={'row'}
            alignItems={'center'}
            spacing={2}
            position={'absolute'}
            sx={{ marginLeft: '2px', margin: '1px', marginTop: '-1px' }}
          >
            <Typography
              sx={{
                ...poppins400,
                fontSize: '12px',
                color: '#9C9C9C',
                marginLeft: '90px',
              }}
            >
              Buyer
            </Typography>
            <Typography
              onClick={() => {
                setOpen(!open);
                setOpenOwner(!openOwner);
              }}
              style={{
                cursor: 'pointer',
                marginTop: '5px',
                marginLeft: '15px',
              }}
            >
              <ToggleOff />
            </Typography>
            <Typography
              sx={{
                ...poppins400,
                fontSize: '12px',
                color: '#112347',
                marginLeft: '90px',
              }}
            >
              Owner
            </Typography>
          </Stack>
        )}

        <>
          {!matchessm &&
          (!expand || matches870) &&
          (showBackdrop || !showBackdrop) ? (
            <IconButton
              onClick={() => {
                setOpen(!open);

                setSelectedBuyerId('');
                {
                  showBackdrop &&
                    setSelectedBuyers((prevBuyers) => {
                      const filter = selectedBuyers.filter(
                        (buyer) => buyer != buyerId
                      );
                      return filter;
                    });
                }
              }}
              sx={{
                position: 'relative',
                left: matches870 && '280px',
              }}
            >
              <RightArrow />
            </IconButton>
          ) : null}
        </>
      </Stack>

      <>
        <Box
          sx={{
            width: matchessm ? '100%' : 'auto',
            height: '110px',
            position: 'relative',
          }}
        >
          <Stack
            sx={{
              width: matchessm ? '100%' : '327px',
              height: '67px',
              marginTop: '5px',
              borderRadius: '10px',
              background: `linear-gradient(180deg, rgba(108, 42, 210, 0.5) 0%, rgba(117, 184, 247, 0.5) 100%)`,
            }}
            justifyContent={'center'}
            alignItems={'center'}
            display={'-webkit-inline-flex'}
          >
            {loading ? (
              ''
            ) : data?.user?.userProfile == '' ||
              data?.user?.userProfile == null ? (
              <Avatar
                style={{
                  height: '91px',
                  width: '91px',
                  border: '4px solid #FFFFFF',
                  marginTop: '60px',
                  backgroundColor: '#666666',
                  fontSize: '40px',
                  fontFamily: 'poppins',
                }}
              >
                {data?.user?.userName.charAt(0)?.toUpperCase() +
                  data?.user?.userSurName.charAt(0)?.toUpperCase()}
              </Avatar>
            ) : (
              <Avatar
                style={{
                  height: '91px',
                  width: '91px',
                  border: '4px solid #FFFFFF',
                  marginTop: '60px',
                }}
                src={data?.user?.userProfile}
              />
            )}
          </Stack>
        </Box>
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            width: '335px',
            height: '30px',
            padding: '0px',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 'calc(100% - 70px)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minWidth: 0,
            }}
          >
            <NameTooltip
              name={data?.user?.userName || ''}
              surname={data?.user?.userSurName || ''}
            >
              <Typography
                sx={{
                  ...poppins600,
                  fontSize: '20px',
                  color: '#000000',
                  display: 'block',
                  width: '100%',
                  minWidth: 0,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  cursor: 'pointer',
                  textAlign: 'center',
                }}
              >
                {`${data?.user?.userName || ''} ${
                  data?.user?.userSurName || ''
                }`.trim()}
              </Typography>
            </NameTooltip>
          </Box>

          <Box
            sx={{
              marginLeft: 'auto',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              flexShrink: 0,
              zIndex: 1,
            }}
          >
            <Avatar
              alt=""
              src={BlueTick}
              sx={{
                height: '16px',
                width: '16px',
                flexShrink: 0,
              }}
            />

            <Avatar
              alt=""
              src={Monetize}
              sx={{
                height: '16px',
                width: '16px',
                flexShrink: 0,
              }}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0px',

            width: '221px',
            height: '18px',
          }}
        >
          <Typography
            sx={{ ...poppins400, fontSize: '12px', color: '#585858' }}
          >
            Buyer Readiness
          </Typography>

          <Avatar
            alt="BuyerReadiness"
            src={BuyerReadiness}
            sx={{ height: '10px', width: '107.5px', borderRadius: '5px' }}
          />
        </Box>
        <Stack
          direction="row"
          spacing={5}
          sx={{
            width: matchessm ? '100%' : '310px',
            justifyContent: 'space-between',
          }}
        >
          <Box sx={{ display: 'flex', gap: '5px' }}>
            {' '}
            <Typography
              sx={{ ...poppins400, fontSize: '14px', color: '#112347' }}
            >
              FHB
            </Typography>
            <Avatar
              src={FHB}
              sx={{ height: '19px', width: '40px', borderRadius: '0px' }}
            />
          </Box>
          <Box>
            <Avatar
              src={Detoast}
              sx={{
                borderRadius: '5px',
                width: '83px',
                height: '28px',
              }}
            />
          </Box>

          <Box sx={{ bottom: '10px' }}>
            <Typography>
              <Select
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                  boxShadow: ' 0px 1px 4px rgba(0, 0, 0, 0.15)',
                  background: '#FFFFFF',

                  border: '1px solid #6C2AD2',
                  borderRadius: '4px',
                  height: '30px',
                  padding: '0px',
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                }}
                size="medium"
                value="10"
                style={{
                  padding: '0px',
                }}
                onChange={() => {}}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
              >
                <MenuItem
                  value={10}
                  sx={{
                    ...poppins500,
                    fontSize: '12px',
                    color: '#112347',
                  }}
                >
                  Action
                </MenuItem>
                <MenuItem
                  value={20}
                  sx={{
                    ...poppins500,
                    fontSize: '12px',
                    color: '#112347',
                  }}
                >
                  Twenty
                </MenuItem>
                <MenuItem
                  value={30}
                  sx={{
                    ...poppins500,
                    fontSize: '12px',
                    color: '#112347',
                  }}
                >
                  Thirty
                </MenuItem>
              </Select>
            </Typography>
          </Box>
        </Stack>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '10px',
            width: matchessm ? '100%' : '340px',
            height: '146px',
            border: '1px solid #E7E5E5',
            borderRadius: '8px',
            justifyContent: 'space-between',
          }}
        >
          {loading ? (
            <Grid
              sx={{
                display: 'flex',
                width: '100%',
                justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center',
                margin: '160px 0',
              }}
            >
              <img
                alt="Logo"
                src={Loading}
                className="loaderImage"
                style={{ height: '50px', width: '50px' }}
              />
            </Grid>
          ) : (
            <Box sx={{ overflowWrap: 'anywhere' }}>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Avatar
                  src={Phone}
                  sx={{
                    borderRadius: '0px',
                    width: '30px',
                    height: '30px',
                    marginBottom: '10px',
                  }}
                />

                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '12px',
                    color: '#585858',
                    marginLeft: '17px',
                    marginTop: '6px',
                  }}
                >
                  {data?.userMobile}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                <Avatar
                  src={Mail}
                  sx={{
                    borderRadius: '0px',
                    width: '30px',
                    height: '30px',
                    marginBottom: '10px',
                  }}
                />
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '12px',
                    color: '#585858',
                    marginLeft: '17px',
                    marginTop: '6px',
                  }}
                >
                  {data?.userEmail}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                <Avatar
                  src={Location}
                  sx={{
                    borderRadius: '2px',
                    width: '30px',
                    height: '30px',
                  }}
                />
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '12px',
                    color: '#585858',
                    marginLeft: '17px',
                    marginTop: '8px',
                  }}
                >
                  {data?.address ? (
                    <>
                      {data?.address?.addressOne}
                      {data?.address?.city}
                      {data?.address?.state}
                      {data?.address?.country}
                      {data?.address?.postalCode}
                    </>
                  ) : (
                    'Address not found'
                  )}
                </Typography>
              </Box>
            </Box>
          )}
          {currentPage.includes('/view-dashboard/1') && (
            <Box
              sx={{
                marginTop: '88px',
                position: 'absolute',
                marginLeft: '160px',
              }}
            >
              <CircularChart />
            </Box>
          )}
          {currentPage.includes('/People') && !isHidden && !expand && (
            <Box
              sx={{
                bottom: '10px',
                marginRight: matchessm ? '5px' : '0px',
                position: 'sticky',
              }}
            >
              <Typography>
                <Select
                  sx={{
                    ...poppins500,
                    fontSize: '12px',
                    color: '#112347',
                    boxShadow: ' 0px 1px 4px rgba(0, 0, 0, 0.15)',
                    background: '#FFFFFF',
                    border: '1px solid #6C2AD2',
                    height: '30px',
                    borderRadius: '5px',
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                    },
                  }}
                  size="medium"
                  value="10"
                  style={{
                    padding: '0px',
                  }}
                  onChange={() => {}}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  <MenuItem
                    value={10}
                    sx={{
                      ...poppins500,
                      fontSize: '12px',
                      color: '#112347',
                    }}
                  >
                    Action
                  </MenuItem>
                  <MenuItem
                    value={20}
                    sx={{
                      ...poppins500,
                      fontSize: '12px',
                      color: '#112347',
                    }}
                  >
                    Twenty
                  </MenuItem>
                  <MenuItem
                    value={30}
                    sx={{
                      ...poppins500,
                      fontSize: '12px',
                      color: '#112347',
                    }}
                  >
                    Thirty
                  </MenuItem>
                </Select>
              </Typography>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            padding: '0',
            gap: '20px',
            width: matchessm ? '100%' : '335px',
            height: '59px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '8px',
              width: '45%',
              height: '100%',
              background: 'rgba(108, 42, 210, 0.1)',
            }}
          >
            <Typography
              sx={{ ...poppins500, fontSize: '16px', color: '#6C2AD2' }}
            >
              {data?.noOfOffers}
            </Typography>
            <Typography
              sx={{ ...poppins400, fontSize: '10px', color: '#666666' }}
            >
              Active
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              height: '100%',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '8px',
              width: '45%',
              backgroundColor: 'rgba(47, 205, 255, 0.12)',
            }}
          >
            <Typography
              sx={{ ...poppins500, fontSize: '16px', color: ' #2FCDFF' }}
            >
              {data?.previouslyOfferMade}
            </Typography>
            <Typography
              sx={{ ...poppins400, fontSize: '10px', color: '#666666' }}
            >
              Offer previously Made
            </Typography>
          </Box>
        </Box>
      </>
    </Box>
  );
};
